angular.module('picmonicng').controller('ResourcesController', [
  '$scope',
  '$filter',
  '$stateParams',
  '$modal',
  '$timeout',
  '$anchorScroll',
  'ResourcesResource',
  'UserService',
  'MetaService',
  'ResourceUpgradeModalService',
  'MarketOptionsConfig',
  '$rootScope',
  function (
    $scope,
    $filter,
    $stateParams,
    $modal,
    $timeout,
    $anchorScroll,
    Resources,
    UserService,
    MetaService,
    ResourceUpgradeModalService,
    MarketOptionsConfig,
    $rootScope
  ) {
    $scope.UserService = UserService;

    Resources.get(
      {
        tab: $stateParams.tab,
      },
      function (resources) {
        $scope.resources = resources;
        $scope.selectTab($filter('filter')($scope.resources.tabs, { slug: $stateParams.tab }, true)[0]);
        $scope.selectCategory($scope.selectedTab.categories[0]);
        $scope.market = MarketOptionsConfig.getMarketById($scope.selectedTab.market_id);

        if ($scope.market.id) {
          UserService.setMarketCookies($scope.market.id);
        }

        if ($stateParams.category) {
          var category = $filter('filter')($scope.selectedTab.categories, { category: $stateParams.category }, true)[0];
          if (category) {
            $timeout(function () {
              $scope.selectCategory(category);
            }, 2000);
          }
        }

        $scope.$emit('endInteraction');
      }
    );

    $scope.selectTab = function (tab) {
      $scope.selectedTab = tab;
    };

    $scope.selectCategory = function (category) {
      // don't scroll for the first category set
      if ($scope.selectedCategory) {
        $timeout(function () {
          $anchorScroll.yOffset = 24;
          $anchorScroll(category.category);
        }, 0);
      }

      $scope.selectedCategory = category;
    };

    $scope.openResource = function (resource) {
      send_ga('event', 'Resources', 'Resource Clicked');

      if (resource.is_premium && UserService.user.is_trial) {
        return $scope.showPremiumModal(resource);
      }

      if (resource.link.indexOf('youtube.com/watch') !== -1) {
        $modal.open({
          templateUrl: '/templates/modals/video-modal.html',
          windowClass: 'learn-light-modal video-modal',
          keyboard: true,
          controller: [
            '$scope',
            function ($scope) {
              $scope.videoUrl = resource.link;
              $scope.title = resource.title;
              $scope.playerVars = {
                autoplay: 1,
                controls: 2,
                color: 'white',
                fs: 0,
                modestbranding: 1,
                rel: 0,
              };
            },
          ],
        });
      } else {
        window.open(
          resource.link.indexOf('http') === 0
            ? resource.link
            : $scope.base_asset_url.indexOf('http') === 0
            ? $scope.base_asset_url + resource.link
            : $scope.base_asset_url.indexOf('//') === 0
            ? 'https:' + $scope.base_asset_url + resource.link
            : resource.link
        );
      }
    };

    $scope.showPremiumModal = function () {
      ResourceUpgradeModalService.show('other_resources');
    };
  },
]);
